import { SystemSettings } from '../objects/SystemSettings';
import { SystemInfo } from '../objects/SystemInfo';

/**
 * @typedef { import('./ApiService').ApiService } ApiService
*/

export class SystemEndpoint {
    /**
     * @param {string} url
     * @param {ApiService} api
     */
    constructor(url, api) {
        this._url = url;
        this._api = api;
    }

    getInfo() {
        return this._api.getResponse(this._url + '/info')
            .then(rsp => new SystemInfo(rsp.getResult(), rsp.context));
    }

    getSettings() {
        return this._api.getResponse(this._url + '/settings')
            .then(rsp => new SystemSettings(rsp.getResult()));
    }

    setSettings(obj) {
        if (!(obj instanceof SystemSettings))
            throw new TypeError("Not a SystemSettings");
        return this._api.putResponse(this._url + '/settings', obj)
            .then(rsp => new SystemSettings(rsp.getResult()));
    }

    updatePublik() {
        return this._api.postVoid(this._url + '/updatepublik');
    }

    applyMunicipalityCodeSettings() {
        return this._api.postVoid(this._url + '/applymunicipality');
    }
}
